document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('.js-product-card');
  
  productCards.forEach(card => {
    const colorDots = card.querySelectorAll('.js-color-dot');
    const productImg = card.querySelector('.js-product-img');
    const variantInput = card.querySelector('.js-variant-input');
    
    if (colorDots.length > 0) {
      colorDots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault(); // Evita che il clic apra la pagina prodotto
          
          // 1. Rimuove la classe active da tutti i pallini di questa card
          colorDots.forEach(d => d.classList.remove('is-active'));
          
          // 2. Aggiunge la classe active al pallino cliccato
          dot.classList.add('is-active');
          
          // 3. Aggiorna l'immagine del prodotto
          const newImgUrl = dot.getAttribute('data-img');
          if (newImgUrl && productImg) {
            // Un leggero fade out/in (gestito anche dal CSS)
            productImg.style.opacity = '0.5';
            setTimeout(() => {
              productImg.src = newImgUrl;
              productImg.srcset = newImgUrl; // Sicurezza per le immagini responsive
              productImg.style.opacity = '1';
            }, 150);
          }
          
          // 4. Aggiorna l'ID variante per il pulsante "Aggiungi al carrello"
          const newVariantId = dot.getAttribute('data-variant-id');
          if (newVariantId && variantInput) {
            variantInput.value = newVariantId;
          }
        });
      });
    }
  });
});